import { formatCurrency } from "@/domains/library"

export const TextTokenValue = ({ value, symbol }: { value: number; symbol: string }) => {
  const valueToFormat = Number.isNaN(value) || !value ? 0 : value
  return (
    <div className="flex flex-row justify-end gap-1">
      <div className="text-t100">{formatCurrency(valueToFormat)}</div>
      <div className="text-t200">{symbol}</div>
    </div>
  )
}
